import React, { useContext, useState, useEffect } from 'react';
// import { filterTags as filterTagsData } from './utils/filter-tags';
import { Link } from 'gatsby';
import Input from './elements/Input';
import Button from './elements/Button';
import FilterTags from './elements/FilterTags';
import FilterButton from './elements/FilterButton';
import { ConfiguratorContext } from '../context/ConfiguratorProvider';

import {
  searchWrap,
  searchFiltersActive,
  searchBrowseWrap,
  searchBrowseWrapFilters,
  filterToggle,
  filterToggleIcon,
  filterTagsSelected,
  filterTagRow,
  filterTagRowWrap,
  filterTagsWrap,
  filterTagsWrapAlt,
} from './search.module.scss';

import {
  // searchBrowseWrap,
  // searchBrowseContainer,
  // dropdownWrap,
  // dropdownInputContainer,
  dropdown,
  dropdownShow,
} from '../templates/homePage.module.scss';

const Search = ({
  // addAltClass,
  isHomePage,
  searchText,
  useOnClickFilter,
  setIsOverflowActive,
  locationsData,
  handleChangeSearchInput,
  // onClickSearchInput,
  onClickSearchButton,
  searchInputValue,
  applySearchFilters,
  pathname,
  filterTags,
}) => {
  const [isDev] = useContext(ConfiguratorContext);
  const [isFiltersActive, setIsFiltersActive] = useState(false);

  const onClickSearchFilter = () => {
    setIsFiltersActive(false);
    setIsOverflowActive(false);
  };

  const handleOnClickFilter = () => {
    setIsFiltersActive(true);
    setIsOverflowActive(true);
  };

  const onClickFilterSingle = (index, filterIndex, tag) => {
    if (filterTags[filterIndex].activeFilterIdx === index) {
      filterTags[filterIndex].activeFilterIdx = null;
      // send data to parent
      applySearchFilters(tag, 'removed', filterTags);
    } else {
      filterTags[filterIndex].activeFilterIdx = index;
      // send data to parent
      applySearchFilters(tag, 'added', filterTags);
    }
  };

  const onClickFilterMultiple = (index, filterIndex, filter, tag) => {
    // Create copy of filterTags
    let filterTagsCopy = [...filterTags];

    if (filterTags[filterIndex].activeFilterIdx.indexOf(index) !== -1) {
      // remove
      let removeIdx = filterTags[filterIndex].activeFilterIdx.indexOf(index);
      filterTagsCopy[filterIndex].activeFilterIdx.splice(removeIdx, 1);

      // send data to parent
      applySearchFilters(filter, tag, 'removed', filterTags);
    } else {
      // add
      filterTagsCopy[filterIndex].activeFilterIdx.push(index);

      // send data to parent
      applySearchFilters(filter, tag, 'added', filterTags);
    }
  };

  const isMultipleFilterSelected = (index, activeFilterIdx) => {
    return activeFilterIdx.indexOf(index) !== -1;
  };

  // TODO: refactor values to env
  const engagementOrElopementPaths = [
    '/wedding/engagement-locations/',
    '/elopement/nyc-elopement-locations/',
  ];

  const { setIsScrollingUp, setPreventScrollEv } =
    useContext(ConfiguratorContext);
  // TODO: refactor to ConfiguratorProvider
  // duplicated code on HomPage
  const handleSearchInputOnClick = () => {
    setPreventScrollEv(true);
    const searchInput = document.getElementById('search-browse');
    // detect mobile devices
    const isMobileDevice = () => {
      return (
        /Mobi|Android/i.test(navigator.userAgent) &&
        !/iPad|Tablet/i.test(navigator.userAgent)
      );
    };
    if (isMobileDevice()) {
      setIsScrollingUp(false);
      // Scroll to location input
      searchInput.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
      // Delay resetting the state to ensure the scroll animation completes
      setTimeout(() => {
        setPreventScrollEv(false);
        // setIsScrollingUp(false);
      }, 35);
    } else {
      // Check the window width
      const windowWidth = window.innerWidth;
      let offset = 0;

      if (windowWidth >= 380 && windowWidth <= 1400) {
        offset = 60;
        const elementPosition = searchInput.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      } else {
        searchInput.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }
  };

  // TODO: refactor from utils
  // correct proper uris for locations
  const getCategoryPath = (categories) => {
    if (categories.includes('nyc-elopement-locations')) {
      return 'elopement/nyc-elopement-locations';
    }
    if (categories.includes('engagement-locations')) {
      return 'wedding/engagement-locations';
    }
    return 'wedding-venues';
  };

  // hanlde search, internal for mobile devices only
  const [searchLocationsData, setSearchLocationsData] = useState(null);
  const [searchResultEmpty, setSearchResultEmpty] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  useEffect(() => {
    let searchResult;
    // detect mobile devices
    const isMobileDevice = () => {
      return (
        /Mobi|Android/i.test(navigator.userAgent) &&
        !/iPad|Tablet/i.test(navigator.userAgent)
      );
    };
    if (isMobileDevice()) {
      if (searchInputValue) {
        // clear any previous search term
        setSearchResultEmpty(false);
        searchResult = locationsData.filter((location) => {
          return (
            location.node.title
              // return location.node.title
              .toLowerCase()
              .split('-')
              .join(' ')
              .includes(searchInputValue.toLowerCase())
          );
        });

        setSearchLocationsData(searchResult);
        setSearchActive(true);
      } else {
        setSearchResultEmpty(true);
        setSearchLocationsData(null);
        setSearchActive(false);
      }

      if (searchResult && searchResult.length === 0) {
        setSearchResultEmpty(true);
        setSearchLocationsData(null);
        setSearchActive(true);
      }
    }
  }, [locationsData, searchInputValue]);

  return (
    <div
      id="search-browse"
      className={`${searchWrap} ${
        isFiltersActive ? `${searchFiltersActive}` : ''
      }`}
    >
      {/* {isDev && <pre>Search</pre>} */}
      <div
        className={
          !isFiltersActive ? searchBrowseWrap : searchBrowseWrapFilters
        }
      >
        {!isFiltersActive && (
          <>
            {pathname === '/wedding/engagement-locations/' ? (
              <p>My engagement photo location is</p>
            ) : (
              <p>I'm getting married at</p>
            )}
            <Input
              id="location"
              type="text"
              text="location"
              labelFor="location"
              labelClassName="labelHidden"
              value={searchInputValue}
              onClick={handleSearchInputOnClick}
              handleChange={handleChangeSearchInput}
            />
            <p>or</p>
            <Button
              className="outlinedBtn"
              customClass="filterBtn"
              text={searchText ? searchText : 'Search'}
              onClick={
                useOnClickFilter ? handleOnClickFilter : onClickSearchButton
              }
            />
            <div
              className={`${dropdown} ${searchActive ? dropdownShow : ''}`}
              style={{ top: '88px' }}
            >
              {searchResultEmpty
                ? 'No results.'
                : searchLocationsData &&
                  searchLocationsData.map((location) => {
                    // Extract slug values from the nodes array
                    const categorySlugs = location.node.categories.nodes.map(
                      // location.node.categories.nodes.map(
                      (node) => node.slug
                    );
                    // Set proper URI
                    const categoryPath = getCategoryPath(categorySlugs);
                    const locationUri = `/${categoryPath}/${location.node.slug}/`;
                    console.log('categorySlugs', location.node.title);
                    return (
                      <Link
                        key={location.node.uri}
                        className=""
                        to={locationUri}
                        // to={location.node.uri}
                        title={location.node.title}
                      >
                        {location.node.title}
                      </Link>
                    );
                  })}
            </div>
          </>
        )}
        {isFiltersActive && (
          <button className={filterToggle} onClick={onClickSearchFilter}>
            <span className={`${filterToggleIcon} material-icons`}>close</span>
          </button>
        )}
      </div>
      <div className={filterTagsSelected}>
        {!isHomePage && (
          <>
            <div className={filterTagRow}>
              <div className={filterTagRowWrap}>
                {filterTags.map(
                  ({ filter, tags, activeFilterIdx }, filterIndex) => (
                    <React.Fragment key={filter}>
                      {[
                        'indoor-outdoor',
                        'other',
                        'budget',
                        'location',
                        'capacity',
                      ].includes(filter) ? (
                        <>
                          {tags.map((tag, index) => (
                            <React.Fragment key={`${filter}-${tag}`}>
                              {isMultipleFilterSelected(
                                index,
                                activeFilterIdx
                              ) && (
                                <FilterButton
                                  key={`${filter}-${tag}`}
                                  className="filterTag"
                                  customClass={
                                    isMultipleFilterSelected(
                                      index,
                                      activeFilterIdx
                                    )
                                      ? 'tagSelected'
                                      : ''
                                  }
                                  text={tag}
                                  name={tag}
                                  onClick={() => {
                                    onClickFilterMultiple(
                                      index,
                                      filterIndex,
                                      filter,
                                      tag
                                    );
                                  }}
                                />
                              )}
                            </React.Fragment>
                          ))}
                        </>
                      ) : (
                        ''
                      )}
                    </React.Fragment>
                  )
                )}
              </div>
            </div>
          </>
        )}
        {isFiltersActive && (
          <div
            className={`${filterTagsWrap} ${engagementOrElopementPaths.includes(pathname) ? `${filterTagsWrapAlt}` : ''}`}
          >
            <FilterTags
              pathName={pathname}
              onClickFilterSingle={onClickFilterSingle}
              onClickFilterMultiple={onClickFilterMultiple}
              isMultipleFilterSelected={isMultipleFilterSelected}
              filterTags={filterTags}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
